import { SignUpEvent } from '../../event'

export function handleSignUp(_event: SignUpEvent) {
  window.dataLayer.push({
    event: 'sign_up',
  })
}
